import { CONF2_ACCOUNT_TYPE } from "../../const";

export const conf2AccountType = {
  type: "string",
  enum: Object.values(CONF2_ACCOUNT_TYPE)
};
